const NS = 'SaveBlockoutDailogCtrl'; // jshint ignore:line

export default function SaveBlockoutDailogCtrl($scope) {
    "ngInject";

    const vm = this;

    vm.cancel = cancel;
    vm.save = save;

    ////////////////

    function cancel() {
        $scope.quickBlockoutsCtrl.closeNewBlockOut();
    }

    function save() {
        $scope.quickBlockoutsCtrl.save();
    }
}
